<template>
  <div class="bq-product-bihuan">
    <SectionTitle :title="'产品简介'"></SectionTitle>
    <p class="title-desc">
      “闭环”是指，将医院内部的关键执行步骤都进行信息电子化，并通过数据仓库采集技术将各执行过程连成的整体，目的在于形成反馈路径，优化业务流程，制定相应的改进措施以达到持续质量改进的目的。
    </p>
    <div class="bihuan-descs">
      <div class="descs-left">
        <div class="line1">闭环管理</div>
        <div class="line2">
          <span>闭环管理</span>
          <span>闭环配置</span>
          <span>闭环分析</span>
        </div>
        <div class="line3">
          <img :src="arrowSrc" alt="" />
          <img :src="arrowSrc" alt="" />
          <img :src="arrowSrc" alt="" />
        </div>
        <div class="line4">DCR</div>
        <div class="line5">
          <img :src="arrowSrc" alt="" />
          <img :src="arrowSrc" alt="" />
          <img :src="arrowSrc" alt="" />
          <img :src="arrowSrc" alt="" />
        </div>
        <div class="line6">
          <span>医院LIS</span>
          <span>医院HIS</span>
          <span>电子病历EMR</span>
          <span>医院RIS</span>
        </div>
      </div>
      <div class="descs-right">
        <div class="descs-text" v-for="item in list" :key="item.title">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <SectionTitle :title="'数据和产品基础'"></SectionTitle>
    <div class="bihuan-list">
      <div class="descs-item">
        <span
          >“闭环管理”依托于标准化数据中心、数据交换平台、主数据管理等基础平台的建设。</span
        >
      </div>
      <div class="descs-item">
        <span
          >实现院内信息的互联互通，进行闭环信息的读取、展现、分析和统计，再嵌入回第三方系统，比如护理系统、LIS系统等。</span
        >
      </div>
    </div>
    <SectionTitle :title="'产品优势'"></SectionTitle>
    <div class="bihuan-adv">
      <InfoBox
        :col="2"
        :itemObj="item"
        v-for="item in datalist"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'bihuan',
  data() {
    return {
      arrowSrc:
        'https://img.alicdn.com/tfs/TB1ffLpDHY1gK0jSZTEXXXDQVXa-16-28.png',
      list: [
        {
          title: '闭环展示',
          desc:
            '将各类型闭环做连贯的图形化展示，且嵌入医生的临床工作中，使医生能够实时了解当前业务流程的闭环进展、操作人员、操作时间等。',
        },
        {
          title: '闭环配置',
          desc:
            '闭环配置使每家医院，都可以结合自身的实际情况，来自定义医院需要的闭环、闭环需要的节点名称及数量，和闭环节点中要显示的内容。',
        },
        {
          title: '闭环分析',
          desc:
            '从时间、业务类型等维度，对闭环的完成情况进行全方位的分析。举例而言，可以了解每个闭环、每个节点的平均耗时，找到耗时较长闭环或节点，以调整业务流程；也可以对院内各项措施、政策，通过闭环环比，直观了解实际的改善情况等等。通过闭环的统计分析，进行精细化管理。',
        },
      ],
      datalist: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB18dujF.Y1gK0jSZFCXXcwqXXa-96-96.png',
          advTitles: '嵌入临床工作',
          advDesc:
            '结合其他产品矩阵，例如患者360视图，和医院本身的医生工作站，能够做到实时查看病人的即时信息，使医生能够实时、快速、便捷地了解当前他关心的业务流程的闭环进展。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1JBmfF.T1gK0jSZFrXXcNCXXa-96-96.png',
          advTitles: '自定义配置',
          advDesc:
            '每家医院，都可以结合自身的实际情况，来自定义闭环的所有内容，且支持随时对内容进行调整。结合闭环分析，可以对比感受每一个提升业务流程的举措所带来的效率变化。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1SDelFYr1gK0jSZFDXXb9yVXa-96-96.png',
          advTitles: '多维度多角度的闭环分析',
          advDesc:
            '从不同业务类型、时间维度对闭环进行多维度、深层次的分析，且支持用户将自己感兴趣的字段进行拖拽，形成实时大表。帮助管理层更加直观、精准地了解医生各个业务流真实、深度的运转情况。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-bihuan {
  width: 1200px;
  margin: 0 auto;
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .bihuan-list {
    display: flex;
    justify-content: space-between;
    .descs-item {
      width: 564px;
      padding: 20px;
      color: #fff;
      background-color: #014dba;
      border-radius: 4px;

      h3 {
        font-size: 20px;
      }

      span {
        font-size: 18px;
        font-weight: 300;
      }

      &:first-child {
        background-color: #003a8c;
      }

      &:last-child {
        background-color: #045bd8;
      }
    }
  }

  .bihuan-descs {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .descs-left {
      color: #1b2591;
      font-size: 18px;
      text-align: center;
      margin-right: 40px;

      .line1,
      .line4 {
        width: 527px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        border: 1px solid rgba(27, 37, 145, 1);
      }

      .line2 {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        span {
          display: inline-block;
          width: 164px;
          height: 96px;
          line-height: 96px;
          border-radius: 4px;
          border: 1px solid rgba(27, 37, 145, 1);
        }
      }
      .line3 {
        display: flex;
        justify-content: space-between;
        img {
          &:first-child {
            position: relative;
            left: 80px;
          }
          &:last-child {
            position: relative;
            right: 70px;
          }
        }
      }
      .line5 {
        display: flex;
        justify-content: space-between;
        img {
          &:first-child {
            position: relative;
            left: 50px;
          }
          &:nth-child(2) {
            position: relative;
            left: 20px;
          }
          &:nth-child(3) {
            position: relative;
            left: -10px;
          }
          &:last-child {
            position: relative;
            right: 50px;
          }
        }
      }

      .line6 {
        display: flex;
        justify-content: space-between;
        span {
          width: 120px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          border: 1px solid rgba(27, 37, 145, 1);
        }
      }
    }

    .descs-right {
      .descs-text {
        color: #333;
        font-size: 20px;
        padding-bottom: 50px;
        h3 {
          margin-bottom: 20px;
        }
        p {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
  }

  .bihuan-adv {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    .bq-infobox {
      width: 350px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }
}
</style>
